/* Rudie cart: "You may also like" (multi, auto, excludes cart items) + one-click upsell toggle. */
(function () {
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function money(c) { var v = c / 100; return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2)); }

  function refreshDrawer(res) {
    if (!res || !res.sections) return;
    var cd = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
    var cur = document.querySelector('#CartDrawer');
    if (cd && cur) cur.innerHTML = cd.innerHTML;
    if (res.sections['cart-icon-bubble']) {
      var doc = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
      var nb = doc.querySelector('.shopify-section') || doc.body.firstElementChild;
      var cb = document.getElementById('cart-icon-bubble');
      if (cb && nb) cb.innerHTML = nb.innerHTML;
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer) { drawer.classList.remove('is-empty'); if (drawer.open) drawer.open(); }
  }
  function cartAdd(variantId, after) {
    fetch(ROOT + 'cart/add', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (res) { refreshDrawer(res); if (after) after(true); }).catch(function () { if (after) after(false); });
  }

  /* ---------- Quick-view info popup ---------- */
  function escapeHtmlG(s) { return (s || '').replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
  function stripText(html) {
    var d = document.createElement('div'); d.innerHTML = html || '';
    d.querySelectorAll('p,div,li,br,h1,h2,h3,h4,h5,h6').forEach(function (el) { el.insertAdjacentText('afterend', ' '); });
    var t = (d.textContent || '').replace(/\s+/g, ' ').trim();
    if (t.length <= 150) return t;
    var cut = t.slice(0, 150);
    var lastDot = cut.lastIndexOf('. ');
    if (lastDot > 70) return cut.slice(0, lastDot + 1);
    return cut.replace(/\s+\S*$/, '') + '…';
  }
  function closeInfo() { var m = document.querySelector('.cart-ymlm'); if (m) m.remove(); document.removeEventListener('keydown', onEsc); }
  function onEsc(e) { if (e.key === 'Escape') closeInfo(); }
  function openInfo(handle) {
    if (!handle) return;
    fetch(ROOT + 'products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var imgs = (p.images || []).slice(0, 4).map(function (u) { return '<img src="' + u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=360" loading="lazy" alt="">'; }).join('');
      var avail = (p.variants || []).filter(function (x) { return x.available; });
      var sel = avail[0] || (p.variants || [])[0] || {};
      function priceHtml(v) { return ((v.compare_at_price && v.compare_at_price > v.price) ? '<s>' + money(v.compare_at_price) + '</s> ' : '') + money(v.price); }
      var pills = avail.length > 1 ? '<p class="cart-ymlm__sizelabel">Size</p><div class="cart-ymlm__sizes">' + avail.map(function (v, i) {
        return '<button type="button" class="cart-ymlm__size" data-vid="' + v.id + '" data-price="' + v.price + '" data-compare="' + (v.compare_at_price || 0) + '" aria-pressed="' + (i === 0 ? 'true' : 'false') + '">' + escapeHtmlG(v.title || v.option1 || '') + '</button>';
      }).join('') + '</div>' : '';
      var desc = stripText(p.description);
      var wrap = document.createElement('div');
      wrap.className = 'cart-ymlm'; wrap.setAttribute('role', 'dialog'); wrap.setAttribute('aria-modal', 'true');
      wrap.innerHTML = '<div class="cart-ymlm__overlay"></div>' +
        '<div class="cart-ymlm__panel">' +
          '<button type="button" class="cart-ymlm__close" aria-label="Close"><svg viewBox="0 0 14 14" fill="none"><path d="M1 1l12 12M13 1L1 13" stroke="#262626" stroke-width="2" stroke-linecap="round"/></svg></button>' +
          (imgs ? '<div class="cart-ymlm__gallery">' + imgs + '</div>' : '') +
          '<h3 class="cart-ymlm__title">' + escapeHtmlG(p.title) + '</h3>' +
          '<div class="cart-ymlm__price">' + priceHtml(sel) + '</div>' +
          (desc ? '<p class="cart-ymlm__desc">' + escapeHtmlG(desc) + '</p>' : '') +
          pills +
          '<button type="button" class="cart-ymlm__add" data-vid="' + (sel.id || '') + '">Add to cart</button>' +
        '</div>';
      document.body.appendChild(wrap);
      wrap.querySelector('.cart-ymlm__overlay').addEventListener('click', closeInfo);
      wrap.querySelector('.cart-ymlm__close').addEventListener('click', closeInfo);
      var addBtn = wrap.querySelector('.cart-ymlm__add');
      var priceEl = wrap.querySelector('.cart-ymlm__price');
      wrap.querySelectorAll('.cart-ymlm__size').forEach(function (b) {
        b.addEventListener('click', function () {
          wrap.querySelectorAll('.cart-ymlm__size').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          addBtn.dataset.vid = b.dataset.vid;
          var pr = parseInt(b.dataset.price, 10), cmp = parseInt(b.dataset.compare, 10);
          priceEl.innerHTML = priceHtml({ price: pr, compare_at_price: cmp });
        });
      });
      if (sel.id) { addBtn.addEventListener('click', function () { var vid = addBtn.dataset.vid; addBtn.disabled = true; addBtn.textContent = 'Adding…'; cartAdd(vid, function (ok) { if (ok) { closeInfo(); } else { addBtn.disabled = false; addBtn.textContent = 'Add to cart'; } }); }); }
      else { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
      document.addEventListener('keydown', onEsc);
    }).catch(function () {});
  }

  /* ---------- You may also like (multi) ---------- */
  if (!customElements.get('cart-upsell')) {
    customElements.define('cart-upsell', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.done) return; this.dataset.done = '1';
        var self = this;
        var pid = this.dataset.productId;
        var inCart = (this.dataset.inCart || '').split(',').filter(Boolean);
        function eligible(list) { return (list || []).filter(function (p) { return p && p.available && inCart.indexOf(String(p.id)) === -1; }); }
        function card(p) {
          var avail = (p.variants || []).filter(function (x) { return x.available; });
          var v = avail[0] || (p.variants || [])[0];
          if (!v) return '';
          var multi = avail.length > 1;
          var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
          var compare = (v.compare_at_price && v.compare_at_price > v.price) ? '<s class="cart-yml__was">' + money(v.compare_at_price) + '</s> ' : '';
          var handle = p.handle || (p.url || '').split('?')[0].replace(/\/+$/, '').split('/').pop();
          var infoSvg = '<svg viewBox="0 0 16 16" fill="#235C43" aria-hidden="true"><circle cx="8" cy="4.3" r="1.15"/><rect x="6.95" y="6.6" width="2.1" height="5.4" rx="1"/></svg>';
          return '<div class="cart-yml__row">' +
              '<a class="cart-yml__media" href="' + p.url + '">' + (img ? '<img src="' + img + '" width="52" height="52" loading="lazy" alt="">' : '') + '</a>' +
              '<div class="cart-yml__body"><a class="cart-yml__title" href="' + p.url + '">' + escapeHtml(p.title) + '</a><span class="cart-yml__price">' + compare + money(v.price) + '</span></div>' +
              '<button type="button" class="cart-yml__info" data-handle="' + escapeHtml(handle) + '" aria-label="More info">' + infoSvg + '</button>' +
              '<button type="button" class="cart-yml__add" data-vid="' + v.id + '" data-handle="' + escapeHtml(handle) + '" data-multi="' + (multi ? '1' : '') + '">Add</button>' +
            '</div>';
        }
        function escapeHtml(s) { return (s || '').replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
        function paint(list) {
          var pick = eligible(list).slice(0, 3);
          if (!pick.length) { self.remove(); return; }
          self.innerHTML = '<p class="cart-yml__label">You may also like</p><div class="cart-yml">' + pick.map(card).join('') + '</div>';
          self.querySelectorAll('.cart-yml__add').forEach(function (btn) {
            btn.addEventListener('click', function () {
              if (btn.dataset.multi) { openInfo(btn.dataset.handle); return; }
              btn.disabled = true; btn.textContent = 'Adding…'; cartAdd(btn.dataset.vid, function (ok) { if (!ok) { btn.disabled = false; btn.textContent = 'Add'; } });
            });
          });
          self.querySelectorAll('.cart-yml__info').forEach(function (btn) {
            btn.addEventListener('click', function () { openInfo(btn.dataset.handle); });
          });
        }
        function fallback() {
          fetch(ROOT + 'products.json?limit=40').then(function (r) { return r.json(); }).then(function (d) {
            paint((d.products || []).map(function (p) {
              return { id: p.id, title: p.title, url: ROOT + 'products/' + p.handle,
                available: (p.variants || []).some(function (v) { return v.available; }),
                featured_image: (p.images && p.images[0]) ? (p.images[0].src || p.images[0]) : '',
                variants: (p.variants || []).map(function (v) { return { id: v.id, available: v.available, price: typeof v.price === 'string' ? Math.round(parseFloat(v.price) * 100) : v.price, compare_at_price: v.compare_at_price ? (typeof v.compare_at_price === 'string' ? Math.round(parseFloat(v.compare_at_price) * 100) : v.compare_at_price) : null }; }) };
            }));
          }).catch(function () { self.remove(); });
        }
        function run() {
          if (!pid) { fallback(); return; }
          fetch(ROOT + 'recommendations/products.json?product_id=' + pid + '&limit=10&intent=related')
            .then(function (r) { return r.json(); })
            .then(function (d) { if (eligible(d.products).length) paint(d.products); else fallback(); })
            .catch(fallback);
        }
        // Refresh the in-cart list from the live cart so we never recommend something already added.
        fetch(ROOT + 'cart.js').then(function (r) { return r.json(); })
          .then(function (c) { if (c && c.items) inCart = c.items.map(function (it) { return String(it.product_id); }); })
          .catch(function () {}).then(run);
      }
    });
  }

  /* ---------- One-click upsell (checkbox) ---------- */
  if (!customElements.get('cart-oneclick')) {
    customElements.define('cart-oneclick', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.done) return; this.dataset.done = '1';
        var self = this;
        var cb = this.querySelector('input[type="checkbox"]');
        var vid = this.dataset.vid;
        if (!cb || !vid) return;
        cb.addEventListener('change', function () {
          cb.disabled = true;
          if (cb.checked) {
            cartAdd(vid, function () { cb.disabled = false; });
          } else {
            // find line + set qty 0
            fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
              var line = 0; (c.items || []).forEach(function (it, i) { if (String(it.variant_id) === String(vid)) line = i + 1; });
              if (!line) { cb.disabled = false; return; }
              fetch(ROOT + 'cart/change', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: line, quantity: 0, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname }) })
                .then(function (r) { return r.json(); }).then(function (res) { refreshDrawer(res); }).catch(function () { cb.disabled = false; });
            });
          }
        });
      }
    });
  }
})();
